import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { quizTexts } from './tileAndButtonTexts';
import TileButton from './components/TileButton';
import AddAnswer from './components/AddAnswer';
import { InteractionContext } from '../../contexts';
import { MULTIPLE_CHOICE, TRUE_FALSE } from '../../utils/constants';
import Text from '../../../../shared/Text';

const TrueOrFalseOptions = ({ values, handleChange }) =>
  values.answers.map((answer, i) => (
    <TileButton
      key={`true_false_button_${i}`}
      buttonText={answer}
      buttonIndex={i}
      correctAnswerIndex={values.correctAnswerIndex}
      withRadio
      onChangeButtonText={handleChange}
    />
  ));

const MultipleChoiceOptions = ({ values, handleChange, handleRemoveAnswer }) =>
  values.answers.map((answer, i) => (
    <TileButton
      key={`multiple_choice_button_${i}`}
      buttonText={answer}
      buttonIndex={i}
      correctAnswerIndex={values.correctAnswerIndex}
      withRadio
      isRemovable={true}
      onRemove={() => handleRemoveAnswer(i)}
      onChangeButtonText={handleChange}
    />
  ));

const QuizItem = ({ option }) => {
  const {
    values,
    handleChange,
    handleAddAnswer,
    handleRemoveAnswer,
    errors,
  } = useContext(InteractionContext);

  const quizErrors = () => {
    return [errors.correctAnswerIndex, errors.answers].filter(Boolean);
  };

  return (
    <>
      {option === TRUE_FALSE && (
        <TrueOrFalseOptions values={values} handleChange={handleChange} />
      )}
      {option === MULTIPLE_CHOICE && (
        <MultipleChoiceOptions
          values={values}
          handleChange={handleChange}
          handleRemoveAnswer={handleRemoveAnswer}
        />
      )}
      <ErrorsWrapper>
        {quizErrors().map(error => (
          <Text as="div" variant="button" key={error} color="error.default">
            {error}
          </Text>
        ))}
      </ErrorsWrapper>
      {option === MULTIPLE_CHOICE && (
        <AddAnswer
          onClick={() => handleAddAnswer(quizTexts[option].buttonText)}
        />
      )}
    </>
  );
};

export default QuizItem;

QuizItem.propTypes = {
  option: PropTypes.string,
};

const ErrorsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
